import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/Home/Home.vue'
import HomeNew from '../pages/Home/HomeNew.vue'
// import Login from '../pages/Login/Login.vue'
import wxLogin from '../pages/wxLogin/wxLogin.vue'
import wxLoading from '../pages/wxLogin/wxLoading.vue'
import Profile from '../pages/Profile/Profile.vue'
import ProfileSettin from '../pages/Profile/ProfileSettin.vue'
import PhoneSettin from '../pages/Profile/PhoneSettin.vue'
import More from '../pages/More/More.vue'
import ServiceDetails from '../pages/More/ServiceDetails/ServiceDetails.vue'
import City from '../pages/City/City.vue'
import TogetherDetails from '../pages/Together/TogetherDetails.vue'
import TogetherOrder from '../pages/Together/TogetherOrder.vue'
import HoursOrder from '../pages/Order/HoursOrder.vue'
import PeriodicOrder from '../pages/Order/PeriodicOrder.vue'
import QuantityOrder from '../pages/Order/QuantityOrder.vue'
import AreaOrder from '../pages/Order/AreaOrder.vue'
import CooperationOrder from '../pages/Order/CooperationOrder.vue'
import HoursOrderEdit from '../pages/OrderEdit/HoursOrderEdit.vue'
import PeriodicOrderEdit from '../pages/OrderEdit/PeriodicOrderEdit.vue'
import QuantityOrderEdit from '../pages/OrderEdit/QuantityOrderEdit.vue'
import AreaOrderEdit from '../pages/OrderEdit/AreaOrderEdit.vue'
import AddressList from '../pages/Address/AddressList.vue'
import AddressDirectories from '../pages/Address/AddressDirectories.vue'
import EditingAddress from '../pages/Address/EditingAddress.vue'
import AddAdderss from '../pages/Address/AddAddress.vue'
import OrderList from '../pages/OrderList/OrderList.vue'
import OrderDetails from '../pages/OrderList/OrderDetails.vue'
import PriceList from '../pages/OrderList/PriceList.vue'
import Assess from '../pages/OrderList/Assess.vue'
import Join from '../pages/Join/Join.vue'
import FinishedPay from '../pages/FinishedPay/FinishedPay.vue'
import Ticket from '../pages/Ticket/index.vue'
import JlActivity from '../pages/JlActivity/index.vue'
import Comment from '../pages/Comment/index.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        showFooter: true
      }
    },
    //新主页
    {
      path: '/home-new',
      name: 'HomeNew',
      component: HomeNew,
      meta: {
        showFooter: false
      }
    },
    /* {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        showFooter: true
      }
    }, */
    {
      path: '/wxlogin',
      name: 'wxLogin',
      component: wxLogin,
      meta: {
        showFooter: false
      }
    },
    {
      path: '/wxloading',
      name: 'wxLoading',
      component: wxLoading,
      meta: {
        showFooter: false
      }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: {
        showFooter: true
      }
    },
    {
      path: '/profileSettin',
      name: 'ProfileSettin',
      component: ProfileSettin,
      meta: {
        showFooter: false
      }
    },
    {
      path: '/phoneSettin',
      name: 'PhoneSettin',
      component: PhoneSettin,
      meta: {
        showFooter: false
      }
    },
    {
      path: '/more',
      component: { template: '<div><router-view></router-view></div>' },
      meta: {
        showFooter: false
      },
      children: [
        {
          path: '',
          name: 'More',
          component: More,
          meta: {
            showFooter: false
          }
        },
        {
          path: 'serviceDetails',
          name: 'ServiceDetails',
          component: ServiceDetails,
          meta: {
            showFooter: false
          }
        }
      ]
    },
    {
      path: '/city',
      name: 'City',
      component: City,
      meta: {
        showFooter: false
      }
    },
    {
      path: '/togetherDetails',
      name: 'TogetherDetails',
      component: TogetherDetails,
      meta: {
        showFooter: false
      }
    },
    {
      path: '/togetherOrder',
      name: 'TogetherOrder',
      component: TogetherOrder,
      meta: {
        showFooter: false
      }
    },
    {
      path: '/hoursorder',
      name: 'HoursOrder',
      component: HoursOrder,
      meta: {
        showFooter: false,
        isCache:true,
        isBack: false
      }
    },
    {
      path: '/periodicorder',
      name: 'PeriodicOrder',
      component: PeriodicOrder,
      meta: {
        showFooter: false,
        isCache:true,
        isBack: false
      }
    },
    {
      path: '/quantityorder',
      name: 'QuantityOrder',
      component: QuantityOrder,
      meta: {
        showFooter: false,
        isCache:true,
        isBack: false
      }
    },
    
    {
      path: '/areaorder',
      name: 'AreaOrder',
      component: AreaOrder,
      meta: {
        showFooter: false,
        isCache:true,
        isBack: false
      }
    },
    {
      path: '/cooperationorder',
      name: 'CooperationOrder',
      component: CooperationOrder,
      meta: {
        showFooter: false,
        isCache:true,
        isBack: false
      }
    },
    {
      path: '/hoursorderedit',
      name: 'HoursOrderEdit',
      component: HoursOrderEdit,
      meta: {
        showFooter: false,
        isCache:true,
        isBack: false
      }
    },
    {
      path: '/periodicorderedit',
      name: 'PeriodicOrderEdit',
      component: PeriodicOrderEdit,
      meta: {
        showFooter: false,
        isCache:true,
        isBack: false
      }
    },
    {
      path: '/quantityorderedit',
      name: 'QuantityOrderEdit',
      component: QuantityOrderEdit,
      meta: {
        showFooter: false,
        isCache:true,
        isBack: false
      }
    },
    {
      path: '/areaorderedit',
      name: 'AreaOrderEdit',
      component: AreaOrderEdit,
      meta: {
        showFooter: false,
        isCache:true,
        isBack: false
      }
    },
    {
      path: '/addresslist',
      name: 'AddressList',
      component: AddressList,
      meta: {
        showFooter: false
      }
    },
    {
      path: '/addressdirectories',
      name: 'AddressDirectories',
      component: AddressDirectories,
      meta: {
        showFooter: false
      }
    },
    {
      path: '/editingaddress',
      name: 'EditingAddress',
      component: EditingAddress,
      meta: {
        showFooter: false
      }
    },
    {
      path: '/addadderss',
      name: 'AddAdderss',
      component: AddAdderss,
      meta: {
        showFooter: false
      }
    },
    {
      path: '/orderlist',
      name: 'OrderList',
      component: OrderList,
      meta: {
        showFooter: false
      }
    },
    {
      path: '/orderdetails',
      name: 'OrderDetails',
      component: OrderDetails,
      meta: {
        showFooter: false
      }
    },
    {
      path: '/pricelist',
      name: 'PriceList',
      component: PriceList,
      meta: {
        showFooter: false
      }
    },
    {
      path: '/assess',
      name: 'Assess',
      component: Assess,
      meta: {
        showFooter: false
      }
    },
    {
      path: '/join',
      name: 'Join',
      component: Join,
      meta: {
        showFooter: false
      }
    },
    {
      path: '/finishedPay',
      name: 'FinishedPay',
      component: FinishedPay,
      meta: {
        showFooter: false
      }
    },
    // 代金券
    {
      path: '/ticket',
      name: 'Ticket',
      component: Ticket,
      meta: {
        showFooter: false
      }
    },
    //接龙活动
    {
      path: '/jl-activity',
      name: 'JlActivity',
      component: JlActivity,
      meta: {
        showFooter: false
      }
    },
    //支付成功后评价
    {
      path: '/comment',
      name: 'Comment',
      component: Comment,
      meta: {
        showFooter: false
      }
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})


// WEBPACK FOOTER //
// ./src/router/index.js